import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { ReportingCategoryContext } from '../context';
import { EditButton } from './editButton';
import { SaveButton } from './saveButton';
import { DeleteButton } from './deleteButton';
import { CancelButton } from './cancelButton';
import messages from '../messages';
import style from '../style.module.less';

const ActionsColumn = ({ categoryId, name, nameValue, setNameValue, idInEditMode = null, setIdInEditMode, setErrorMessage }) => {
  const { setNeedsReload, needsReload } = useContext(ReportingCategoryContext);

  return (
    <>
      <span className={style.saveEditButton}>
        {idInEditMode && idInEditMode === categoryId ? (
          <SaveButton
            categoryId={categoryId}
            name={name}
            nameValue={nameValue}
            setErrorMessage={setErrorMessage}
            setIdInEditMode={setIdInEditMode}
          />
        ) : (
          <EditButton categoryId={categoryId} name={name} setIdInEditMode={setIdInEditMode} setNameValue={setNameValue} />
        )}
      </span>
      {idInEditMode && idInEditMode === categoryId ? (
        <CancelButton setErrorMessage={setErrorMessage} setIdInEditMode={setIdInEditMode} />
      ) : (
        <DeleteButton categoryId={categoryId} needsReload={needsReload} setNeedsReload={setNeedsReload} />
      )}
    </>
  );
};

ActionsColumn.propTypes = {
  categoryId: PropTypes.number.isRequired,
  nameValue: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setNameValue: PropTypes.string.isRequired,
  setIdInEditMode: PropTypes.func.isRequired,
  idInEditMode: PropTypes.string,
  setErrorMessage: PropTypes.func.isRequired,
};

export const actions = {
  getMessageDescriptor: () => <FormattedMessage {...messages.actionsColumn} />,
  id: 'actions',
  isSortable: false,
  render: ActionsColumn,
};
